export default {
  incrementCounter({ commit }) {
    commit('INCREMENT_COUNTER')
  },
}
